<div class="payment-info">
  <!-- START: Empty line items -->
    <!-- If line items array is empty we show only the footer  -->
    <div class="vox-card" [ngClass]="{'vox-card--only-total': estimate.line_items.length == 0}"
         *ngIf="!loading && estimate && estimate.line_items.length == 0">
        <div class="footer-card-container">
            <gdp-footer-card
            [estimate]="estimate"
            [locale]="country"
            [showCredits]="estimate[selectedTab].credits_applied && estimate[selectedTab].credits_applied > 0">
            </gdp-footer-card>
        </div>
    </div>
    <!-- END: Empty line items -->

    <!-- START: Conflict error disclaimer -->
    <div class="vox-inline-message vox-inline-message_light-grey" *ngIf="errorConflict">
      <div>
          <i class="icon-small-alert"></i>
          <span translate>{{errorConflict}}</span>
          <a  class="btn-retry-estimate" (click)="fetchEstimate()">Retry</a>
      </div>
    </div>
    <!-- END: Conflict error disclaimer -->

    <!-- START: Recap card with tabs -->
    <div *ngIf="showTabs && !loading.box && !errorConflict">
      <ul ngbNav #nav="ngbNav" [(activeId)]="selectedTab" [animation]="false" (navChange)="onSelectTab($event)" class="nav-tabs">
        <li [ngbNavItem]="TABS_TYPE.immediate">
          <a ngbNavLink translate>payment-info.tabs.immediate.title</a>
          <ng-template ngbNavContent>
            <ng-container
            *ngTemplateOutlet="recapTemplate; context: { message: 'payment-info.tabs.immediate.subtitle' }">
            </ng-container>
          </ng-template>
        </li>
        <li [ngbNavItem]="TABS_TYPE.renewal">
          <a ngbNavLink translate>payment-info.tabs.renewal.title</a>
          <ng-template ngbNavContent>
            <ng-container
            *ngTemplateOutlet="recapTemplate; context: { message: 'payment-info.tabs.renewal.subtitle' }">
            </ng-container>
          </ng-template>
        </li>
      </ul>
      
      <div [ngbNavOutlet]="nav"></div>
    </div>
    <!-- END: Recap card with tabs -->

    <!-- START: Only IMMEDIATE tab  -->
    <!-- If we don't have ONE_TIME charges we show a card without tabs -->
    <div class="vox-card" *ngIf="!showTabs && !loading.box && !errorConflict">
      <ng-container *ngTemplateOutlet="recapTemplate; context: { message: 'upgrade-plan-recap.tabs.immediate.title' }"></ng-container>
    </div>
    <!-- END: Only IMMEDIATE tab -->

    <div *ngIf="loading.box">
        <ngx-skeleton-loader [theme]="{ 'height': '385px' }"></ngx-skeleton-loader>
    </div>
</div>

<ng-template #recapTemplate let-message="message">
  <div *ngIf="!loading.lines" class="header-card">
      <p class="header-card__header vox-paragraph">
          <i *ngIf="showTabs" class="icon-small-info"></i>
          {{ message | translate }}
      </p>
      <div class="bill-container">
        <!-- Plan items -->
        <div class="header-card__bill" *ngFor="let p of items[selectedTab].recurrent.plans">
            <gdp-line-item class="line-item" 
            [item]="p" 
            [currency]="estimate.currency_code" 
            [locale]="country"
            [planData]="planData">
            </gdp-line-item>
        </div>
        <!-- Addon items -->
        <div *ngFor="let p of items[selectedTab].recurrent.addons" class="header-card__bill">
            <gdp-line-item class="line-item" 
            [item]="p" 
            [currency]="estimate.currency_code" 
            [locale]="country"
            [showItemData]="p.quantity > 1">
            </gdp-line-item>
        </div>
      </div>

      <!-- Discount items -->
      <div *ngFor="let coupon of coupons[selectedTab]; let i = index">
          <div *ngIf="coupon.duration !== 'one_time'" class="header-card__discount">
              <gdp-discount-item class="discount-item"
              [canRemove]="selectedTab !== TABS_TYPE.renewal && canModifyCoupon"
              [coupon]="coupon"
              [currency]="estimate.currency_code"
              [locale]="country"
              (onRemoveCoupon)="removeCoupon(i)">
              </gdp-discount-item>
          </div>
      </div>
      <!-- Discount items for ONE_TIME coupon -->
      <div *ngIf="(couponOneTime && selectedTab !== TABS_TYPE.renewal) || items[selectedTab].one_time.addons.length !== 0">
            <span class="header-card__header vox-paragraph" translate>
                payment-info.one-time
            </span>
            <div class="bill-container">
                <!-- Addon ONE_TIME items -->
                <div class="header-card__bill" *ngFor="let a of items[selectedTab].one_time.addons">
                    <gdp-line-item class="line-item" 
                    [item]="a" 
                    [currency]="estimate.currency_code" 
                    [locale]="country">
                    </gdp-line-item>
                </div>
            </div>
            
            <div *ngFor="let coupon of coupons[selectedTab]; let i = index">
                <div class="header-card__discount">
                    <gdp-discount-item class="discount-item"
                    [canRemove]="selectedTab !== TABS_TYPE.renewal && canModifyCoupon"
                    [coupon]="coupon"
                    [currency]="estimate.currency_code"
                    [locale]="country"
                    (onRemoveCoupon)="removeCoupon(i)">
                    </gdp-discount-item>
                </div>
            </div>
      </div>
      <!-- Footer -->
      <div class="footer-card-container">
          <gdp-footer-card
          [estimate]="items[selectedTab].estimation"
          [locale]="country">
          </gdp-footer-card>
          <!-- Coupon form -->
          <div *ngIf="selectedTab === TABS_TYPE.renewal && canModifyCoupon" class="coupon-form__header">
            <span translate>payment-info.coupon-form.not-editable</span>
          </div>
          <gdp-coupon-form
          *ngIf="selectedTab !== TABS_TYPE.renewal && canModifyCoupon"
          [chargebeeAccount]="chargebeeAccount"
          [couponExist]="couponExist"
          (couponChange)="couponChange($event)">
          </gdp-coupon-form>
      </div>
  </div>
  <!-- START: Skeleton Loader -->
  <div class="header-card" *ngIf="loading.lines">
      <div class="header-card__header">
          <span>
              <ngx-skeleton-loader [theme]="{ width: '140px', height: '16px','margin-bottom': '0px','margin-top': '0px'  }"></ngx-skeleton-loader>
          </span>
      </div>
      <div class="header-card__bill">
          <div class="item-name">
            <span>
              <ngx-skeleton-loader [theme]="{ width: '300px', height: '16px','margin-bottom': '0px','margin-top': '0px'  }">
              </ngx-skeleton-loader>
            </span>
          </div>
          <div class="item-price">
              <span class="full-price"></span>
              <span class="discounted-price">
                  <ngx-skeleton-loader [theme]="{ width: '50px', height: '16px','margin-bottom': '0px','margin-top': '0px' }">
                  </ngx-skeleton-loader>
              </span>
          </div>
      </div>
      <div class="footer-card">
          <div class="footer-card__total">
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '140px', height: '16px','margin-bottom': '0px','margin-top': '0px'  }"></ngx-skeleton-loader>
              </span>
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '50px', height: '16px','margin-bottom': '0px','margin-top': '0px'  }"></ngx-skeleton-loader>
              </span>
          </div>
          <div class="footer-card__total">
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '70px', height: '16px', 'margin-bottom': '0px','margin-top': '0px' }"></ngx-skeleton-loader>
              </span>
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '50px', height: '16px' , 'margin-bottom': '0px', 'margin-top': '0px'}"></ngx-skeleton-loader>
              </span>
          </div>
          <hr>
          <div class="footer-card__total footer-card__total-up">
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '70px', height: '16px', 'margin-bottom': '0px','margin-top': '0px' }"></ngx-skeleton-loader>
              </span>
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '40px', height: '16px', 'margin-bottom': '0px','margin-top': '0px' }"></ngx-skeleton-loader>
              </span>
          </div>
          <div class="footer-card__link">
              <span>
                  <ngx-skeleton-loader [theme]="{ width: '160px', height: '16px', 'margin-bottom': '0px', 'margin-top': '0px' }"></ngx-skeleton-loader>
              </span>
          </div>
      </div>
  </div>
  <!-- END: Skeleton Loader -->
</ng-template>